<template lang="pug">
  #email-modal.modal-card(style='width: auto')
    header.modal-card-head.is-flex-direction-column
      WtTitle.mb-0.has-text-centered Email Preview
    section.modal-card-body
      WtTitle.mb-0 Sent on
      .mb-4 {{ date(email.sentOn, "DATE_TIME_FORMAT").formatted }}
      WtTitle.mb-0 Sent to
      .mb-4 {{ sentToText }}
        .mb-0.ml-2.is-family-secondary(v-if="email.filter === 'individualUsers'" v-for="(val, index) in email.members") {{ val.email }}
      WtTitle.mb-0 Subject
      .mb-4 {{ email.subject }}
      WtTitle.mb-0 Body
      WtTile.custom-style(parent padding="small")
        WtDisplayRichTextHTML(:html="email.body")
    footer.modal-card-foot
      WtButton.button.is-danger(@click.native="closeEmailModal") Close
</template>

<script>
import { mapActions } from "vuex";
import WtButton from "@@/WtButton/WtButton";
import WtTitle from "@@/WtTitle/WtTitle";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import WtDisplayRichTextHTML from "@@/WtDisplayRichTextHTML/WtDisplayRichTextHTML";
import WtTile from "@@/WtTile/WtTile";

export default {
  name: "MemberCenterAdminEmailArchiveModal",

  components: { WtTile, WtButton, WtTitle, WtDisplayRichTextHTML },

  mixins: [dateUtilityMixin],

  props: {
    email: {
      type: Object,
      required: true
    },
    featuredChallenges: {
      type: Array,
      default: null
    }
  },

  computed: {
    sentToText() {
      const sentToTextObject = {
        allMembers: "All members",
        atRiskMembers: "Members with no activity in the past 30 days",
        individualUsers: "Individual users:"
      };
      if (this.email.featuredChallengeSelected) {
        const challenge = this.featuredChallenges.find(
          el => el.id === this.email.featuredChallengeSelected
        );
        let challengeName = this._.get(challenge, "name", "");
        const sameText = `a featured challenge(${challengeName})`;
        sentToTextObject.inFeaturedChallenge = `In ${sameText}`;
        sentToTextObject.notInFeaturedChallenge = `Not in ${sameText}`;
      }
      return sentToTextObject[this.email.filter];
    }
  },
  methods: {
    ...mapActions("members", ["changePassword"]),
    ...mapActions(["snackBar"]),

    closeEmailModal() {
      this.$emit("emailModalOpen", false);
    }
  }
};
</script>

<style lang="sass" scoped>
.custom-style
  background-color: $grey-light
  border-radius: $radius-large
</style>
